import { forIn } from "lodash";
import React from "react";
type FakeData<U extends boolean, T> = U extends true ? T : string;
interface RenderTypePreviewProps<T, U extends boolean> {
  data: T;
  multi?: U;
  fakeData: FakeData<U, T>;
  from?: string | undefined;
  element?: React.FunctionComponent<{
    content: T | FakeData<U, T>;
  }>;
}
function RenderTypePreviewData<T, U extends boolean>({
  data,
  fakeData,
  from,
  element: Component,
  multi = false as U
}: RenderTypePreviewProps<T, U>): JSX.Element {
  if (from === "type" && from && !multi) {
    if (!Component) {
      //@ts-ignore
      return <>{data}</>;
    }
    //@ts-ignore
    return data ? <Component content={data} /> : <>{data}</>;
  } else if (Component && multi) {
    if (from) {
      const statusValue = () => {
        let status = false;
        forIn(data, value => {
          status = !(!value && !status);
        });
        return status;
      };
      return statusValue() ? <Component content={data} /> : <></>;
    }
    forIn(data as Record<string, unknown>, (value, key) => {
      !value && (value = fakeData[key as keyof typeof fakeData]);
    });
    return <Component content={data} />;
  } else {
    if (!Component) {
      //@ts-ignore
      return <>{data || fakeData}</>;
    }
    return <Component content={data || fakeData} />;
  }
}
export default RenderTypePreviewData;